import { Div } from "./Div";
import { Tag } from "./Tag";
import { Anchor } from "./Anchor";
import { Entity } from "../Entity/Entity";
import { toMap, getDataRepository, getWebPageService, getService4App } from "../../../HA";

export class Module extends Div {

    protected initialize(data: any) {
        super.initialize(data);
        this.addClass("mod");
        this.setActive(true);
        this.setId(Entity.genId());
        this.loadData();

        if (this.has("upinternal")) {
            const interval = setInterval(() => {
                this.loadData();
            }, this.get("upinternal"));
            const [appId, subscriptionId] = getWebPageService().subscribeToAppInfo((info: Map<string, any>) => {
                if (info.get("s") === -1) {
                    clearInterval(interval);
                    getWebPageService().unsubscribeToAppInfo(subscriptionId);
                    return;
                }
                this.setActive(appId === info.get("id"));
            });
        }
    }

    private loadData() {
        if (!this.isActive()) {
            return;
        }
        getDataRepository().fetchData(this.get("d")).then((response: Map<any, any>) => {
            const app = toMap(response.get("app") as any);
            if (!app || !app.has("mod")) {
                return;
            }
            const md = toMap(app.get("mod") as any);
            const d = toMap(md.get("d") as any);
            d.set("trans", md.get("trans"));
            if (md.has("class")) {
                this.addClass(md.get("class"));
            } else if (md.has("classes")) {
                this.addClasses(md.get("classes"));
            }
            this.clear();
            this.appendChild(new Tag(d));
            this.initAnchors(this);
        });
    }

    private initAnchors(tag: Tag = this) {
        const anchors = tag.fetchByTagName("a");
        anchors.forEach((anchor: Tag) => {
            if (anchor.getAttribute("i")) {
                return;
            }
            anchor.setAttribute("i", "1");
            const data = new Map();
            data.set("tag", anchor);
            data.set("services", getService4App());
            new Anchor(data);
        });
    }

    protected isActive(): boolean {
        return this.get("isActive");
    }

    protected setActive(active: boolean): void {
        this.addToData("isActive", active);
    }
}
